import React, { useEffect, useState } from "react";
import { useAuth } from "../context/AuthContext";
import api from "../lib/api";
import Schedule from "./Schedule";
import AdminLayout from "../components/AdminLayout";

export default function PractitionerDay() {
  const { user } = useAuth();
  const [profile, setProfile] = useState(null);   // their practitioner record
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    api.get("/practitioners/me")
      .then(({ data }) => setProfile(data))
      .catch(() => setProfile(false))
      .finally(() => setLoading(false));
  }, []);

  if (loading) {
    return (
      <AdminLayout>
        <p className="text-sm font-ui text-slate" data-testid="practitioner-loading">Loading your schedule…</p>
      </AdminLayout>
    );
  }

  if (!profile) {
    return (
      <AdminLayout>
        <div className="max-w-xl bg-white border border-hairline rounded-lg shadow-warm p-8" data-testid="no-practitioner-profile">
          <p className="font-mono text-xs uppercase tracking-[0.18em] text-sage mb-2">— My schedule</p>
          <h1 className="font-display text-2xl text-charcoal mb-2">No practitioner profile yet.</h1>
          <p className="text-sm font-ui text-slate">
            Your staff account isn't linked to a practitioner record. Ask an admin to link your account on the Practitioners page,
            and your day/week/month schedule will appear here.
          </p>
        </div>
      </AdminLayout>
    );
  }

  // Schedule renders its own LogVisitDialog when an event card is clicked, so the
  // practitioner view inherits the Log-Visit + Add-on flow automatically.
  return (
    <Schedule
      scopedPractitionerId={profile.id}
      allowedTabs={["day", "week", "month", "by_day"]}
      title={`Hi ${user?.name?.split(" ")[0] || "there"} — your schedule`}
      subtitle={`${profile.display_name} · Click any appointment to log the visit.`}
      showQuickAction={false}
      enableCellCreate={false}
    />
  );
}
